import { CustomElement, resolve } from 'aurelia';
import { UiService } from '../../services';
import template from './legal-modal.html';
import './legal-modal.css';

// Terms/Privacy/Disclaimer content modal shown from the footer. Renders only while
// UiService.legalOpen is set; the title/body html and open/close behavior live in UiService.
export class LegalModalElement {
  readonly ui: UiService = resolve(UiService);
}

export const LegalModal = CustomElement.define({
  name: 'legal-modal',
  template
}, LegalModalElement);
